import { Outlet } from 'react-router-dom';
import { APP_SHELL_MENU, onResolveShellNav } from '../../../_Config/AppShell.Layout';
import { useSectionTitle } from '../../Hooks/Hooks/useSectionMetaTitle';
import { useLanguage } from '../../Hooks/Contexts/Translate/useLanguageContext';

export const AppLayoutPublic = ({ outletContext = {} }) => {

    const { useDataLanguage } = useLanguage();

    const SHELL_NAV = onResolveShellNav(null, useDataLanguage.currentLang);

    useSectionTitle(SHELL_NAV.publicRoutes, APP_SHELL_MENU.brand.name);

    return (
        <div className="LStudio__app_shell LStudio__app_shell--public">
            <main className="LStudio__app_shell__main">
                <Outlet context={outletContext} />
            </main>
        </div>
    );
};
